import React from 'react';
import { DeprecatedTab } from './tab';
import { DeprecatedTabButton } from './tab-button';
import { DeprecatedTabContent } from './tab-content';

const tabType = (
  <DeprecatedTab>
    <DeprecatedTabButton />
    <DeprecatedTabContent />
  </DeprecatedTab>
).type;

export const tabsChildValidator = (props, propName) => {
  const childrenProp = props[propName];
  if (!childrenProp) {
    return new Error('Must have children!');
  }
  const childs = Array.isArray(childrenProp) ? childrenProp : [childrenProp];
  const allAreTabsOrFalseRender = childs.every((child) => child.type === tabType || child === false);
  if (!allAreTabsOrFalseRender) {
    return new Error('All children must be tab elements');
  }
  return null;
};
